import { useQuery } from '@pylot-data/hooks/use-query'
import { WISHLIST_QUERY } from '../graphql/wishlistQuery'
import type { RequestInit } from '@vercel/fetch'
import type { SWRConfiguration } from 'swr'
import type { Customer } from '@pylot-data/pylotschema'
import { useUser } from '@corratech/pylot-auth-manager'

export interface OutputInterface {
    customer: Customer
}

export const useWishlist = (
    swrOptions?: SWRConfiguration,
    fetchOptions?: RequestInit
) => {
    // We can run wishlist query only when we know that the user is logged in
    const { isSignedIn, customer } = useUser({
        revalidateOnFocus: false,
        revalidateOnMount: false,
        revalidateOnReconnect: false
    })
    const swrResponse = useQuery<null, OutputInterface>(
        isSignedIn && customer ? WISHLIST_QUERY : null,
        null,
        {
            ...swrOptions,
            revalidateOnMount: Boolean(isSignedIn)
        },
        fetchOptions
    )
    const loading = !swrResponse?.data && !swrResponse?.error
    const wishlists = swrResponse?.data?.data?.customer?.wishlists

    const getWishlistById = (id: string) => {
        if (!wishlists?.length || id == null || id === '') return null
        const needle = String(id)
        return wishlists.find((wl) => String(wl?.id) === needle) ?? null
    }

    return {
        loading,
        wishlists,
        getWishlistById,
        ...swrResponse
    }
}
